import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import propTypes from 'prop-types';
import Icon from '../icon/icon';

const {
	bool, func, string, arrayOf, shape
} = propTypes;

function RadioGroup (props) {
	if (props.hide) { return null; }

	const updateAndBlur = ev => {
		props.onChange(ev);
		props.onBlur(ev);
	};

	const radioButton = ({ value, display, enabled }) => {
		let id = `${props.name}-${value}`;
		let labelClassNames = classnames({
			'radio-inline': true,
			'lss-mid-grey': !enabled,
			'vertical': props.verticalLayout,
			'disabled': !enabled
		});

		let radioClassNames = classnames({
			'checked': value === props.value && enabled,
			'not-checked': value !== props.value || !enabled,
			'disabled': !enabled
		});

		return [(
			<label className={labelClassNames} key={id} htmlFor={id}>
				<input
					id={id}
					type='radio'
					className={radioClassNames}
					name={props.name}
					value={value}
					onChange={updateAndBlur}
					onBlur={props.onBlur}
					checked={props.checked && props.checked === value}
					disabled={!enabled}
				/>
				<Icon name={props.checked && props.checked === value ? 'MdRadioButtonChecked' : 'MdRadioButtonUnchecked'} />
				{display}
			</label>
		), props.verticalLayout ? <br key={`vertical-br-${id}`} /> : null
		];
	};

	return (
		<div className='form-group radio-group'>
			{props.label && <span className='lss-form-label'>{props.label}<br /></span>}
			<div className={props.verticalLayout ? 'radio-vertical-container' : 'radio-inline-container'}>
				{_.flatten(props.options.map(radioButton))}
				{props.formError && <span className='error-message'>{props.formError}</span>}
			</div>
		</div>
	);
}

RadioGroup.propTypes = {
	label: string,
	name: string.isRequired,
	onChange: func,
	onBlur: func,
	formError: string,
	value: string.isRequired,
	options: arrayOf(shape({
		value: string.isRequired,
		display: string.isRequired,
		enabled: bool
	})),
	verticalLayout: bool,
	checked: string
};

export default RadioGroup;
